<wa-dialog label="Filter Exams" (waHide)="cancel()" open="true" withFooter="true">
  <form [formGroup]="filterForm">
    <div class="wa-stack">
      <wa-input label="Module code"
                type="text"
                formControlName="moduleCode"
                placeholder="Code">
      </wa-input>
      <!--wa-button variant="neutral" appearance="outlined" (click)="filterForm.get('moduleCode')?.reset()"-->
      <wa-input label="Module name"
                type="text"
                formControlName="moduleName"
                placeholder="module name">
      </wa-input>
      <!--wa-button variant="neutral" appearance="outlined" (click)="filterForm.get('moduleName')?.reset()"-->
      <label for="examTypeSelect">Exam type</label>
      <select id="examTypeSelect"
              type="text"
              formControlName="examTypeId">
        @for (examType of examTypes; track examType.id) {
          <option [value]="examType.id">{{ examType.name }}</option>
        }
      </select>
      <!--wa-button variant="neutral" appearance="outlined" (click)="filterForm.get('examTypeId')?.reset()"-->
      <div class="wa-grid">
        <wa-input label="Date from"
                  type="date"
                  formControlName="begin">
        </wa-input>
        <!--wa-button variant="neutral" appearance="outlined" (click)="filterForm.get('begin')?.reset()"-->
        <wa-input label="Date until"
                  type="date"
                  formControlName="end">
        </wa-input>
        <!--wa-button variant="neutral" appearance="outlined" (click)="filterForm.get('end')?.reset()"-->
      </div>
      <div class="wa-grid">
        <wa-input label="Participants from"
                  type="number"
                  formControlName="participantsFrom">
        </wa-input>
        <!--wa-button variant="neutral" appearance="outlined" (click)="filterForm.get('begin')?.reset()"-->
        <wa-input label="Participants to"
                  type="date"
                  formControlName="participantsTo">
        </wa-input>
        <!--wa-button variant="neutral" appearance="outlined" (click)="filterForm.get('end')?.reset()"-->
      </div>
      <wa-checkbox formControlName="isRepetition">retake exam</wa-checkbox>
    </div>
  </form>
<div slot="footer">
  <div class="wa-cluster">
    <wa-button variant="neutral" appearance="filled" (click)="cancel()">Cancel</wa-button>
    <wa-button
      variant="brand"
      (click)="apply()">
      Apply
    </wa-button>
  </div>
</div>
</wa-dialog>
